import React, { type FC } from "react";

import { type Filters } from "../../../utils/queryUtils";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getEmailFilters } from "./emailFilters";

export interface EmailFilterFormForPacksProps {
  filterOptions: Filters;
  updateFilter: (filter: Filters) => void;
  filter: Filters;
  onValidationChange?: (propertyName: string, isValid: boolean) => void;
}
export const EmailFilterFormForPacks: FC<EmailFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getEmailFilters(false)}
    onValidationChange={onValidationChange}
  />
);
